import React from 'react';
import TableWrapper from '../../../shared/components/TableWrapper';
import { Form, Select, Table, Button, Dropdown, Menu } from 'antd';
import { useRef } from 'react';
import './TableSummary.css';
import { useEffect } from 'react';
import { useState } from 'react';
import UI from '../../../shared/react-native/UI/js';
import { View, StyleSheet, Text } from '../../../shared/custom-react-native';
import FormWrapper from '../../../shared/components/FormWrapper';
import { CSVLink } from 'react-csv';
import ReactToPrint from 'react-to-print';
import jsPDF from 'jspdf';
import Moment from 'moment';
import { DateRangePicker } from 'react-date-range';
import { TreeSelect } from 'antd';
import { treeData, useDateRange } from '../../../shared/hooks/useDateRange';
import { BiReset } from 'react-icons/bi';
function TableSummary_supervisor(props) {
  const ref = useRef(null);

  const { summary, categories, isLoading, setIsLoading } = props;
  const componentRef = useRef();
  const [form] = Form.useForm();
  const [columnData, setColumnData] = useState([]);
  const [headerData, setHeaderData] = useState([]);
  const [filterDateValue, setFilterDateValue] = useState('');
  const [filterValue, setFilterValue] = useState('');
  const [rowData, setRowData] = useState([]);
  const [currentCategory, setCurrentCategory] = useState('');
  const [allData, setAllData] = useState([]);
  const [currentType, setCurrentType] = useState('encoder');
  const [isshowDate, setisshowDate] = useState(true);
  const [hotReloadStart, setHotReloadStart] = useState(false);
  const [selectionRange, setSelectionRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    },
  ]);
  const handleClickOutside = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      setisshowDate(true);
    }
  };

  const columnEncoder = [
    {
      title: 'Encoder',
      dataIndex: 'full_name',
      key: 'full_name',
    },
    {
      title: 'On Time',
      dataIndex: 'on_time_reports_count',
      key: 'on_time_reports_count',
    },
    {
      title: 'Corrected',
      dataIndex: 'reports_count',
      key: 'reports_count',
    },
    {
      title: 'Late',
      dataIndex: 'late_reports_count',
      key: 'late_reports_count',
    },
    {
      title: '# of Reports',
      dataIndex: 'reports_count',
      key: 'reports_count',
    },
  ];
  const columnOffice = [
    {
      title: 'Office',
      dataIndex: 'unit',
      key: 'unit',
    },
    {
      title: 'On Time',
      dataIndex: 'on_time_reports_count',
      key: 'on_time_reports_count',
    },
    {
      title: 'Corrected',
      dataIndex: 'corrected_reports_count',
      key: 'corrected_reports_count',
    },
    {
      title: 'Late',
      dataIndex: 'late_reports_count',
      key: 'late_reports_count',
    },
    {
      title: '# of Reports',
      dataIndex: 'reports_count',
      key: 'reports_count',
    },
  ];

  const load_data = async (id, filter_by = '') => {
    console.log(id, filter_by);
    setIsLoading(true);
    setCurrentCategory(id);

    UI.apiRequest({
      method: 'get',
      url: 'summary-reports',
      params: {
        search: '',
        per_page: '1000',
        category: id,
        start_date: filter_by.formatDateStart ? filter_by.formatDateStart : '',
        end_date: filter_by.formatDateEnd ? filter_by.formatDateEnd : '',
        type: currentType,
      },
      onSuccess: (d) => {
        const {
          data,
          total_corrected_reports,
          total_late_reports,
          total_on_time_reports,
          total_reports,
        } = d;
        const totallistData = {
          on_time_reports_count: total_on_time_reports,
          corrected_reports_count: total_corrected_reports,
          late_reports_count: total_late_reports,
          reports_count: total_reports,
        };
        console.log(d);
        if (currentType === 'encoder') {
          console.log(columnEncoder);
          process_data(columnEncoder, data, {
            ...totallistData,
            full_name: 'Total',
          });
        }
        if (currentType === 'office') {
          console.log(data);
          console.log(columnOffice);
          process_data(columnOffice, data, {
            ...totallistData,
            unit: 'Total',
          });
        }

        setAllData(data);
      },
      onFail: (data) => {},
      isMultiPart: false,
      onFinish: () => {
        form.setFields([{ name: 'category', value: id }]);
        setIsLoading(false);
      },
    });
  };
  const process_data = (data_col, data_row, total) => {
    let data = data_col.map((item) => {
      const obj = {
        title: item.title,
        dataIndex: item.key,
        render: (row, rowData) => {
          return renderTableItem(rowData[item.key]);
        },
      };
      return obj;
    });

    let header = data_col.map((item) => {
      const obj = {
        label: item.title,
        key: item.key,
      };
      return obj;
    });
    console.log(data_row);
    console.log(total);
    const newdata = [...data_row, total];
    console.log(newdata);
    setColumnData(data);
    setHeaderData(header);

    // console.log("data_row", data_row);
    setRowData(newdata);
  };
  const renderTableItem = (text) => {
    return (
      <div>
        <p className='border px-5 py-2 text-center rounded-md'>{text}</p>
      </div>
    );
  };
  const filterByUnit = (e) => {
    setFilterValue(e);

    if (e) {
      const filteredData = allData.filter((data) => {
        return data.unit == e;
      });

      setRowData(filteredData);
      return;
    }

    setRowData(allData);
  };
  const onFilterByDate = (e) => {
    setFilterDateValue(e);
    load_data(currentCategory, e);
  };
  const downloadPDF = () => {
    if (columnData && rowData) {
      const doc = new jsPDF({
        orientation: 'l',
        unit: 'pt',
        format: [5000, 1000],
      });
      doc.setFontSize(10);

      const filteredColumnData = columnData.map((item) => item.dataIndex);
      const values = rowData.map((elemento) => Object.values(elemento));

      let content = {
        head: [filteredColumnData],
        body: values,
      };

      // console.log(values);

      doc.text('Summary Report', 10, 10);
      doc.autoTable(content);
      doc.save('Summary.pdf');

      // console.log(doc);
    }
  };
  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);
  useEffect(() => {
    if (hotReloadStart) {
      const formatDateStart = Moment(selectionRange[0].startDate).format(
        'MM/DD/YYYY',
      );
      const formatDateEnd = Moment(selectionRange[0].endDate).format(
        'MM/DD/YYYY',
      );
      const params = { formatDateStart, formatDateEnd };
      console.log(params);
      // dispatch(getInfoOperationList(params));
      load_data(currentCategory, params);
    }
  }, [selectionRange]);
  useEffect(() => {
    console.log(currentType);
  }, [currentType]);
  useEffect(() => {
    console.log('chheck');
    if (categories.length > 0) {
      load_data(categories[0].id, 'daily');
    }

    //process_data(cols, rows);
  }, [categories]);
  const useDateRange = (dispatch, key) => (e) => {
    console.log(e);
    let date = new Date().getFullYear();

    let params = {
      formatDateStart: Moment(`01/01/${date}`).format('MM/DD/YYYY'),
      formatDateEnd: Moment(new Date()).format('MM/DD/YYYY'),
    };
    if (e === 'first_quarter') {
      params = {
        formatDateStart: `01/01/${date}`,
        formatDateEnd: `03/31/${date}`,
      };
    }
    if (e === 'second_quarter') {
      params = {
        formatDateStart: `04/01/${date}`,
        formatDateEnd: `06/30/${date}`,
      };
    }
    if (e === 'third_quarter') {
      params = {
        formatDateStart: `07/01/${date}`,
        formatDateEnd: `09/30/${date}`,
      };
    }
    if (e === 'fourth_quarter') {
      params = {
        formatDateStart: `10/01/${date}`,
        formatDateEnd: `12/31/${date}`,
      };
    }
    if (e === 'annually') {
      params = {
        formatDateStart: `01/01/${date}`,
        formatDateEnd: `12/31/${date}`,
      };
    }
    if (e === 'jan') {
      params = {
        formatDateStart: `01/01/${date}`,
        formatDateEnd: `01/31/${date}`,
      };
    }
    if (e === 'feb') {
      params = {
        formatDateStart: `02/01/${date}`,
        formatDateEnd: `03/01/${date}`,
      };
    }
    if (e === 'mar') {
      params = {
        formatDateStart: `03/01/${date}`,
        formatDateEnd: `03/31/${date}`,
      };
    }
    if (e === 'april') {
      params = {
        formatDateStart: `04/01/${date}`,
        formatDateEnd: `04/30/${date}`,
      };
    }
    if (e === 'may') {
      params = {
        formatDateStart: `05/01/${date}`,
        formatDateEnd: `05/31/${date}`,
      };
    }
    if (e === 'jun') {
      params = {
        formatDateStart: `06/01/${date}`,
        formatDateEnd: `06/30/${date}`,
      };
    }
    if (e === 'jul') {
      params = {
        formatDateStart: `07/01/${date}`,
        formatDateEnd: `07/31/${date}`,
      };
    }
    if (e === 'aug') {
      params = {
        formatDateStart: `08/01/${date}`,
        formatDateEnd: `08/31/${date}`,
      };
    }
    if (e === 'sept') {
      params = {
        formatDateStart: `09/01/${date}`,
        formatDateEnd: `09/30/${date}`,
      };
    }
    if (e === 'oct') {
      params = {
        formatDateStart: `10/01/${date}`,
        formatDateEnd: `10/31/${date}`,
      };
    }
    if (e === 'nov') {
      params = {
        formatDateStart: `11/01/${date}`,
        formatDateEnd: `11/30/${date}`,
      };
    }
    if (e === 'dec') {
      params = {
        formatDateStart: `12/01/${date}`,
        formatDateEnd: `12/31/${date}`,
      };
    }
    load_data(currentCategory, params);
  };
  return (
    <div className='sub-container p-5 md:p-10'>
      <View style={{ paddingLeft: 20, display: 'flex' }}>
        <FormWrapper className='flex'>
          <Form
            form={form}
            className='flex flex-row flex-wrap gap-2'
          >
            <Form.Item
              name={'category'}
              className='flex-1 md:w-auto'
            >
              <Select
                placeholder='Categories'
                onChange={(e) => {
                  load_data(e, filterDateValue);
                }}
              >
                {categories.map((item) => {
                  return <option value={item.id}>{item.name}</option>;
                })}
              </Select>
            </Form.Item>
            {UI.box(30)}
            <Form.Item
              name={'type'}
              className='flex-1 md:w-auto'
            >
              <Select
                placeholder='Type'
                onChange={(e) => {
                  setCurrentType(e);
                  load_data(currentCategory, filterDateValue);
                }}
              >
                <option value={'encoder'}>Encoder Submission Report</option>
                <option value={'office'}>Office Submission Report </option>
              </Select>
            </Form.Item>
            {UI.box(30)}
            <div className='h-11 d-flex'>
              <TreeSelect
                size='middle'
                style={{ width: '100%' }}
                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                treeData={treeData}
                placeholder='Please select'
                onChange={useDateRange('info_operation')}
              />
              <Button
                className='bg-blue-10 text-white h-11 mx-2'
                onClick={() => {
                  onFilterByDate('');
                }}
              >
                <BiReset size={18} />
              </Button>
            </div>

            {UI.box(30)}

            <div className=' d-flex'>
              <Form.Item className='custom-date-label'>
                <p className='absolute z-50 flex  bg-white px-2 border border-gray-300 h-11 items-center rounded-tl-md rounded-bl-md'>
                  Filter by:
                </p>
                <Button
                  className='buttonDate '
                  style={{
                    cursor: 'pointer',
                    border: '1px solid #C5C5C5',
                    height: '44px',
                    borderLeft: 'none',
                    minWidth: '190px',
                  }}
                  placeholder='Date'
                  onClick={() => {
                    return setisshowDate((prev) => {
                      if (!hotReloadStart) {
                        setHotReloadStart(true);
                      }
                      if (prev) {
                        setisshowDate(false);
                      } else {
                        setisshowDate(true);
                      }
                    });
                  }}
                >
                  Date
                </Button>
              </Form.Item>
              <Button
                hidden
                htmlType='submit'
              ></Button>
              <div
                onClick={() => {
                  onFilterByDate('');
                }}
              >
                <Button className='bg-blue-10 mx-2 w-full md:w-auto text-white h-11 md:mr-5 mb-5 md:mb-0'>
                  Reset Filter
                </Button>
              </div>
            </div>
            {UI.box(30)}

            <Form.Item className='flex-1 md:w-auto'>
              <ReactToPrint
                trigger={() => (
                  <Button className='bg-blue-10 w-full md:w-auto text-white h-11 md:mr-5 mb-5 md:mb-0'>
                    Print
                  </Button>
                )}
                content={() => componentRef.current}
              />

              {rowData && columnData && (
                <Dropdown
                  className='bg-blue-10 w-full md:w-auto text-white h-11 md:mr-5 mb-5 md:mb-0'
                  overlay={
                    <Menu>
                      <Menu.Item>
                        <CSVLink
                          data={rowData}
                          headers={headerData}
                          filename={'Summary'}
                        >
                          Excel
                        </CSVLink>
                      </Menu.Item>
                      <Menu.Item>
                        <p onClick={downloadPDF}>PDF</p>
                      </Menu.Item>
                    </Menu>
                  }
                  placement='bottomCenter'
                >
                  <Button>Export</Button>
                </Dropdown>
              )}
            </Form.Item>
          </Form>
        </FormWrapper>
      </View>
      <TableWrapper className='px-2'>
        <Table
          id='summaryTable'
          loading={isLoading}
          columns={columnData}
          dataSource={rowData}
          pagination={true}
          scroll={{ x: 1000 }}
          ref={componentRef}
        />
      </TableWrapper>
      <div
        className='container'
        style={{
          display: isshowDate ? 'none' : 'block',
        }}
        ref={ref}
      >
        <DateRangePicker
          editableDateInputs={true}
          onChange={(item) => setSelectionRange([item.selection])}
          moveRangeOnFirstSelection={false}
          ranges={selectionRange}
        />
      </div>
    </div>
  );
}

export default TableSummary_supervisor;
